import React from 'react';
import LogoutButton from '../buttons/LogoutButton';
import '../../styles/topbar.css';
import { Link } from 'react-router-dom';

class TopBarReunion extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className='top-bar'>
                <div>
                    <Link to='/timeline'>Back to Reunion Timeline</Link>
                </div>
                <div>
                    <LogoutButton />
                </div>
            </div>
        );
    }
}

export default TopBarReunion;
